var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-status"},[_c('font-awesome-icon',{staticClass:"application-status__icon",class:("application-status__icon--" + _vm.status),attrs:{"icon":_vm.icon}}),_vm._v(" "),(_vm.date)?_c('small',[_c('sba-time-ago',{attrs:{"date":_vm.date}})],1):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aeaed28","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-status.vue
// module id = null
// module chunks = 